import { Box } from "@mui/material";
import CircularProgress, { circularProgressClasses } from "@mui/material/CircularProgress";
import { useEffect, useState } from "react";

interface SpinnerProps {
  backgroundColor?: string;
  fillColor?: string;
}
const SpinnerWithNoConfirmation = (props: SpinnerProps) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let timer1 = setInterval(() => {
      setProgress((prevProgress) => (prevProgress >= 100 ? 0 : prevProgress + 5));
    }, 100);

    return () => {
      clearInterval(timer1);
    };
  }, [progress, props]);

  return (
    <Box sx={{ position: "relative", display: "flex", alignItems: "center" }}>
      <CircularProgress variant="determinate" sx={{ color: props?.backgroundColor ? props?.backgroundColor : (theme) => theme.palette.grey[theme.palette.mode === "light" ? 200 : 800], opacity: props?.backgroundColor ? 0.2 : 1 }} size={50} thickness={6} {...props} value={100} />
      <CircularProgress
        variant="determinate"
        sx={{
          color: props?.fillColor ? props?.fillColor : (theme) => (theme.palette.mode === "light" ? "#053742" : "#053742"),
          animationDuration: "1.2s",
          position: "absolute",
          left: 0,
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: "round",
          },
        }}
        size={50}
        thickness={6}
        {...props}
        value={progress}
      />
    </Box>
  );
};

export default SpinnerWithNoConfirmation;
